module.exports = __webpack_public_path__ + "img/DW365-316.561a6da9.jpg";